import {
    CreateCalendarGroupDocument,
    CreateCalendarGroupMutation,
} from '../graphql/__generated__/createCalendarGroupMutation.interface';

import type { MailboxInfo } from 'owa-client-ids';
import { getApolloClient } from 'owa-apollo';

export type CreateCalendarGroupResult = CreateCalendarGroupMutation['createCalendarGroup'];

/**
 * Creates a calendar group on server
 * @param {string} groupName The name of new calendar group to create
 * @returns The response with the created group's id
 */
export default async function createCalendarGroupService(
    groupName: string,
    mailboxInfo: MailboxInfo
): Promise<CreateCalendarGroupResult> {
    const client = await getApolloClient();
    const mutationResult = await client.mutate({
        variables: {
            newCalendarGroupName: groupName,
            mailboxInfo: mailboxInfo,
        },
        mutation: CreateCalendarGroupDocument,
    });

    return mutationResult?.data?.createCalendarGroup;
}
